import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import RegistrationFormService from '../services/RegistrationFormService';
import ValidateableTextInputField from "./ValidateableTextInputField";

class SecurityQuestionAnswer extends Component {

  validateValue = (value) => {
    return RegistrationFormService.validateSecurityQuestionAnswer(value);
  };

  render() {
    return (
        <React.Fragment>
          <ValidateableTextInputField
              validationFunction={this.validateValue}
              onChange={this.props.onChange}
              fieldLabel={this.props.fieldLabel}
              showErrors={this.props.showErrors}
          />
        </React.Fragment>
    )
  }
}

SecurityQuestionAnswer.propTypes = {
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool
};

export default SecurityQuestionAnswer;